import React, { useEffect, useState, useMemo, useRef } from "react";
import { useForm } from "react-hook-form";
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import axios from "axios";
import "mapbox-gl/dist/mapbox-gl.css";
import { URL_BASE } from "../../config/url-server";
import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";
import trapService from "../../services/health-trap-service";
import { Divider, Spin } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import healthTrapService from "../../services/health-trap-service";

const HealthTrapMap = () => {


    const [selectedPoint, setSelectedPoint] = useState(null);
    const [trapsLayer, setTrapsLayer] = useState(null);
    const [centerMap, setCenterMap] = useState({ lat: 10.5582, lng: -74.1915 });
    const selectingTrap = useRef(false);

    const [filtersOpen, setFiltersOpen] = useState(true);


    const [loading, setLoading] = useState(false);


    const [sectionId, setSectionId] = useState("0");

    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listSection, setListSection] = useState(escoja);
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);
    const [sessionUser, setSessionUser] = useState("admin");
    const [showSave, setShowSave] = useState(true);
    const [showEdit, setShowEdit] = useState(false);


    ///Aplicaciones por dia
    const [lotId, setLotId] = useState("0");
    const [farmId, setFarmId] = useState("0");

    const clientId = localStorage.getItem("client")
    const accessToken = localStorage.getItem("token")
    const [lotPolygons, setLotPolygons] = useState([]);

    //5.391078, -73.869958
    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });

    const polygonOpacity = 0.2;
    const polygonColor = "#52d346";
    const selectedLotColor = "#FFD700";

    const optionsState = [
        { id: true, name: "ACTIVO" },
        { id: false, name: "INACTIVO" },
    ];






    const getFarmLotPolygons = async (farmId) => {
        if (!farmId || farmId === "0") {
            setLotPolygons([]);
            return;
        }
        try {
            const params = {
                farmId
            };
            const configRequest = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`
                },
                params
            };
            const response = await axios.get(
                URL_BASE + "map/get-farm-polygons",
                configRequest
            );
            const polygons = response?.data?.data || [];
            setLotPolygons(polygons);
        } catch (error) {
            console.error(
                "Error obteniendo polígonos de los lotes:",
                error
            );
            setLotPolygons([]);
        }
    };


    const lotPolygonsGeoJson = useMemo(() => {

        return {
            type: "FeatureCollection",

            features: lotPolygons
                .filter(lot =>
                    lot.lotPolygon?.type === "Polygon" &&
                    lot.lotPolygon?.coordinates?.length > 0
                )
                .map((lot, index) => {

                    return {
                        type: "Feature",

                        geometry: {
                            type: "Polygon",
                            coordinates: lot.lotPolygon.coordinates
                        },

                        properties: {
                            id: lot._id,
                            name: lot.name,
                            lotCode: lot.lotCode,
                            color: String(lot._id) === String(lotId)
                                ? selectedLotColor
                                : polygonColor
                        }
                    };
                })
        };

    }, [lotPolygons, lotId]);


    const lotPolygonsLayer = lotPolygons.length > 0 ? (
        <Source
            id="lot-polygons"
            type="geojson"
            data={lotPolygonsGeoJson}
        >
            <Layer
                id="lot-polygons-fill"
                type="fill"
                paint={{
                    "fill-color": ["get", "color"],
                    "fill-opacity": polygonOpacity
                }}
            />

            <Layer
                id="lot-polygons-line"
                type="line"
                paint={{
                    "line-color": ["get", "color"],
                    "line-width": 2,
                    "line-opacity": 0.9,
                    "line-dasharray": [3, 2]
                }}
            />

            <Layer
                id="lot-polygons-label"
                type="symbol"
                layout={{
                    "text-field": ["get", "name"],
                    "text-size": 12,
                    "text-allow-overlap": true
                }}
                paint={{
                    "text-color": "#FFFFFF",
                    "text-halo-color": "#000000",
                    "text-halo-width": 2
                }}
            />
        </Source>
    ) : null;



    const {
        register,
        getValues,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();


    const getLisFarm = async () => {
        if (farmId == "0") {
            let listado = await farmService.getList();
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListFarms(sortedItems);
            }
        }
    };

    const getListSection = async (e) => {

        setLotPolygons([]);
        setTrapsLayer(null)
        const code = e.target.value;
        if (code == "0") {
            setListSection(escoja);
            setListLots(escoja);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
            setFarmId(code);
            return;
        }
        let listado = await sectionService.getListByFarm(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListSection(sortedItems);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
        }

        setFarmId(code);
        await getFarmLotPolygons(code);
    };

    const getLisLots = async (e) => {
        const code = e.target.value;
        setSectionId(code)
        if (code == "0") {
            setListLots(escoja);
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await lotService.getListBySection(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListLots(sortedItems);
            setValue("lot", "0")
            setValue("user", "0")
        }
    };




    const getGeoTrapsByFarm = async (farm) => {


        if (farm == "0") return;
        let response = await healthTrapService.getGeoTrapsByFarm(farm);

        const traps = response.data;


        if (traps.length > 0) {
            const middle = Math.floor(traps.length / 2);
            const coords = traps[middle]?.location?.coordinates;

            if (coords && coords.length === 2) {
                const lat = coords[1];
                const lng = coords[0];
                setCenterMap({ lat, lng });

                setViewState({
                    latitude: lat,
                    longitude: lng,
                    zoom: 18,
                });
            }


        }



        const filterCoord = traps.map((item, index) => {
            const [lng, lat] = item.location.coordinates;
            const name = `${item.name}`;
            return (
                <Marker
                    key={`lot-palm-${index}`}
                    longitude={lng}
                    latitude={lat}
                    anchor="center"
                    onClick={(event) => {
                        selectingTrap.current = true;
                        event.originalEvent.stopPropagation();
                        getTrap(item._id);
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "white",
                            border: `2px solid #000`,
                            padding: "2px 4px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "10px",
                            color: "#000",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                        }}
                        title={name}
                    >
                        {name}
                    </div>
                </Marker>
            );
        });
        setTrapsLayer(filterCoord)
    }





    useEffect(() => {
        getLisFarm();
        const username = localStorage.getItem("username");
        setSessionUser(username)
    }, []);


    useEffect(() => {

        if (!lotPolygonsGeoJson?.features?.length) {
            return;
        }

        const coordinates = [];

        lotPolygonsGeoJson.features.forEach(feature => {

            const rings = feature.geometry.coordinates;

            rings.forEach(ring => {

                ring.forEach(([lng, lat]) => {

                    coordinates.push([lng, lat]);

                });

            });

        });

        if (coordinates.length === 0) {
            return;
        }

        let minLng = coordinates[0][0];
        let maxLng = coordinates[0][0];
        let minLat = coordinates[0][1];
        let maxLat = coordinates[0][1];

        coordinates.forEach(([lng, lat]) => {

            minLng = Math.min(minLng, lng);
            maxLng = Math.max(maxLng, lng);

            minLat = Math.min(minLat, lat);
            maxLat = Math.max(maxLat, lat);

        });

        const centerLng = (minLng + maxLng) / 2;
        const centerLat = (minLat + maxLat) / 2;

        setViewState(prev => ({
            ...prev,
            longitude: centerLng,
            latitude: centerLat,
            zoom: 15
        }));

    }, [lotPolygonsGeoJson]);



    const nameToUpper = (e) => {
        let value = e.target.value.toUpperCase();
        setValue("name", value);

    };


    const customSubmit = async (data) => {
        if (lotId == "0") {
            toast.error('Seleccione un lote', { autoClose: 1000 });
            return;
        }
        setLoading(true)
        const response = await trapService.insert(data);
        if (response.success) {
            const farm = getValues("farm")
            cleanForm()
            toast('Realizado.', { autoClose: 1000 });            
            getGeoTrapsByFarm(farm)
        }
        else {
            toast.error(response.data.message, { autoClose: 2100 })
        }
        setLoading(false)
    };


    const updateTrap = async () => {

        const data = getValues()
        if (lotId == "0") {
            toast.error('Seleccione un lote', { autoClose: 1000 });
            return;
        }
        setLoading(true)
        const response = await trapService.update(data);
        if (response.success) {
            const farm = getValues("farm")
            cleanForm()
            toast('Realizado.', { autoClose: 1000 });
            getGeoTrapsByFarm(farm)
        }
        else {
            toast.error(response.data.message, { autoClose: 2100 })
        }
        setLoading(false)

    }



    const getTrap = async (trapId) => {
        try {
            setLoading(true);

            // Aquí consultaremos la información completa de la trampa
            const response = await trapService.getHealthTrap(trapId);
            console.log("la response:", response)
            console.log(response.success)
            if (response.success) {
                console.log("entra por el success")
                const trap = response.data
                setValue("id", trap._id)
                setValue("name", trap.name)
                setValue("lot", trap.lotId)
                setValue("latitude", trap.latitude)
                setValue("longitude", trap.longitude)

                setShowEdit(true);
                setShowSave(false);

                selectingTrap.current = false;
            }
            else {

                console.log("NOO entra por el success")
            }

            // Próximo paso:
            // const response = await healthTrapService.getTrap(trapId);
            // Cargar los datos recibidos en el formulario.

        } catch (error) {
            console.error("Error consultando la trampa:", error);
            toast.error("Error consultando la trampa");
        } finally {
            setLoading(false);
        }
    };

    const cleanForm = async () => {
        setShowEdit(false);
        setShowSave(true);
        setValue("id", "");
        setValue("name", "");
        setValue("latitude", "");
        setValue("longitude", "");
        setValue("state", true);
    };


    useEffect(() => {
        ///load traps
    }, [sectionId, farmId, sectionId]);

    return (
        <div className="row">
            <ToastContainer />


            <div className="col-12 col-sm-2">
                {/* ACORDEÓN 1: FILTROS */}
                <div className="card mb-2">
                    <button
                        type="button"
                        className="btn btn-light text-start d-flex justify-content-between align-items-center fw-bold"
                        onClick={() => setFiltersOpen(!filtersOpen)}
                        aria-expanded={filtersOpen}
                    >
                        <span>
                            <i className="bi bi-archive me-2" />
                            Datos de la trampa
                        </span>

                        <i className={`bi ${filtersOpen ? "bi-chevron-up" : "bi-chevron-down"}`} />
                    </button>

                    {filtersOpen && (
                        <div className="card-body p-2">
                            <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
                                <div className="row">

                                    <div className=" col-12 d-none">
                                        <label className="text-secondary fw-bold">Id de trampa</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("id")}
                                        />
                                    </div>



                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Finca</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("farm")}
                                            onChange={(e) =>{

                                                getListSection(e)
                                                getGeoTrapsByFarm(e.target.value)
                                            } 


                                            }
                                        >
                                            {listFarms.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="  col-12 col-sm-12">
                                        <label className="text-secondary fw-bold">Sección</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("section")}
                                            onChange={(e) => getLisLots(e)}
                                        >
                                            {listSection.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Lote</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("lot")}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setLotId(value);
                                            }}
                                        >
                                            {listLots.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>



                                    <div className=" col-12">

                                        <label className="text-secondary fw-bold">Nombre trampa</label>
                                        <input
                                            type="text"
                                            onKeyUp={nameToUpper}
                                            className="form-control"
                                            {...register("name", { required: true, minLength: 1 })}
                                        />
                                        {errors.name?.type === "required" && (
                                            <small className="text-danger">Campo requerido</small>
                                        )}
                                        {errors.name?.type === "minLength" && (
                                            <small className="text-danger">Minimo 1 caracteres</small>
                                        )}
                                    </div>




                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Latitud</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("latitude", { required: true, minLength: 3 })}
                                        />
                                        {errors.latitude?.type === "required" && (
                                            <small className="text-danger">Campo requerido</small>
                                        )}
                                    </div>


                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Longitud</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("longitude", { required: true, minLength: 3 })}
                                        />
                                        {errors.longitude?.type === "required" && (
                                            <small className="text-danger">Campo requerido</small>
                                        )}
                                    </div>


                                    <div className=" col-12">
                                        <label>Estado</label>
                                        <select className="form-control" {...register("state")}>
                                            {optionsState.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>



                                    <div className={showEdit ? " col-12 mt-4" : "d-none"}>
                                        <Spin spinning={loading}>
                                            <button
                                                className="btn btn-success w-100"
                                                type="button"
                                                onClick={() => updateTrap()}
                                            >
                                                <i className="bi bi-save fa-lg me-2" /> Editar
                                            </button>
                                        </Spin>
                                    </div>


                                    {/* Botón Guardar */}

                                    <div className={showSave ? " col-12 mt-4" : "d-none"}>
                                        <Spin spinning={loading}>
                                            <button className="btn btn-primary w-100" type="submit">
                                                <i className="bi bi-save fa-lg me-2" />
                                                Guardar
                                            </button>
                                        </Spin>
                                    </div>


                                    <div className=" col-12">
                                        <label>&nbsp; </label>
                                        <Spin spinning={loading}>
                                            <button
                                                className="btn btn-secondary w-100"
                                                type="button"
                                                onClick={() => cleanForm()}
                                            >
                                                <i className="bi bi-x-square fa-lg m-2" /> Cancelar
                                            </button>
                                        </Spin>
                                    </div>

                                </div>
                            </form>
                        </div>
                    )}
                </div>

            </div>


            <div className="col-12 col-sm-10">
                <Map
                    onClick={(event) => {
                        if (selectingTrap.current) {
                            selectingTrap.current = false;
                            return;
                        }

                        const lng = event.lngLat.lng.toFixed(9);
                        const lat = event.lngLat.lat.toFixed(9);
                        if (lng.length > 10)
                            setValue("latitude", lat)
                        setValue("longitude", lng)
                    }}
                    interactiveLayerIds={[
                        "movement-points",
                        "movement-first",
                        "movement-last"
                    ]}
                    {...viewState}
                    onMove={evt => setViewState(evt.viewState)}
                    style={{ width: "100%", height: "100vh" }}
                    mapStyle="mapbox://styles/mapbox/satellite-v9"
                    mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
                >
                    <NavigationControl position="top-left" />


                    {/* Capa de poligonos */}
                    {lotPolygonsLayer}


                    {/*capa de trampas*/}
                    {trapsLayer}


                </Map>
            </div>
        </div>
    );
};

export default HealthTrapMap;